module.exports = __webpack_public_path__ + "img/portfolio-img1.4c96cefb.png";